import { IActionFn, IPageData } from '@/store/types';
import { IModuleState } from './types';
import { $asset, $http } from '@/axios';

// 查询已发布的导航
export const queryFurNavTrees: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  const compName = payload ? `Component_${payload}` : 'Component';
  const furName = payload ? `Furniture_${payload}` : 'Furniture';
  const fetchCompPublished = $asset('oss', `data/navigation_${compName}.json`, { ignoreCodes: [404] });
  const fetchFurPublished = $asset('oss', `data/navigation_${furName}.json`, { ignoreCodes: [404] });

  commit('setFurNavTrees', { ...state.navTrees, loading: true });
  Promise.all([fetchCompPublished, fetchFurPublished]).then((results) => {
    const [compTrees = null, furTrees = null] = results || [];

    // 注意: compTree 的位置不能换
    // 这里表示 compTree 的根节点里没有 id 时, 则 id 值用 -1 填充; 有 id 时, 则使用请求结果里的 id
    const compRoot = compTrees ? { id: -1, entityType: 'Component', ...compTrees, name: '零件' } : null;
    const furRoot = furTrees ? { id: -2, entityType: 'Furniture', ...furTrees, name: '模块' } : null;
    commit('setFurNavTrees', { raw: [compRoot, furRoot].filter((item) => !!item) });
  }).catch(() => {
    commit('setFurNavTrees', { raw: [] });
  });
};

// 查询零件或模块列表(图片列表)
export const queryFurImgList: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    const { entity, ...rest } = payload;
    const postMap: Record<string, string> = {
      Component: '/v1/asset/component/search',
      Furniture: '/v1/asset/block/search',
    };
    commit('setFurImgList', { ...state.imgList, loading: true });
    const res: IPageData = await $http.post(postMap[entity], rest);
    commit('setFurImgList', {
      data: res.list, pageNum: res.pageNum, pageSize: res.pageSize,
      total: res.total, params: payload,
    });
  } catch (e) {
    commit('setFurImgList', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};
